import debounce from 'debounce'

export class SearchBar extends HTMLElement {
  constructor() {
    super()

    this.onInput = this.onInput.bind(this)
    this.startSearch = this.startSearch.bind(this)
    this.fetchTags = debounce(this.fetchTags.bind(this), 500)

    this.languageSlug = ''

    this.input = null
    this.loading = false

    this.firstLoad = true

    this.tagList = null

    this.apiEndpoint = '/wp-json/front/v1/search_tags'
    this.query = ''
    this.searchButton = null

    this.isOpen = false

    this.tags = []
  }

  connectedCallback() {
    this.input = this.querySelector('#search')
    this.searchButton = this.querySelector('[data-search-start]')
    this.tagList = this.querySelector('[data-tag-list]')
    this.languageSlug = this.dataset.lang
    
    if (this.input) {
      this.input.addEventListener('input', this.onInput)
    }
    if (this.searchButton) {
      this.searchButton.addEventListener('click', this.startSearch)
    }
    this.fetchTags()
  }

  disconnectedCallback() {
    if (this.input) {
      this.input.removeEventListener('input', this.onInput)
    }
  }

  onInput(event) {
    this.query = event.target.value
    this.fetchTags()
  }

  startSearch(e) {
    if(this.query.length > 0) {
      window.location.href = `${window.location.origin}/?s=${this.query}`
    }
  }

  displayTags(tags) {
    this.tags = tags
    const tagElements = this.getElementsForTags(tags)
    if (this.tagList.children.length > 0) {
      this.switchTags(tagElements)
    } else {
      if (!tagElements) {
        return
      }
      tagElements.forEach((li) => {
        this.tagList.appendChild(li)
      })
      this.switchTags(tagElements)
    }
  }

  switchTags(newTags) {
    this.tagList.children &&
      gsap.to(this.tagList.children, { autoAlpha: 0, y: 5, duration: 0.2 })
    this.tagList.innerHTML = ''

    if (!newTags) {
      return
    }
    newTags.forEach((li) => {
      this.tagList.appendChild(li)
    })
    if (this.firstLoad) {
      return
    }

    if (this.tagList.children && this.tagList.children.length > 0) {
      gsap.fromTo(
        this.tagList.children,
        { autoAlpha: 0, y: 5 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.25,
          stagger: 0.02,
          ease: 'power2.out'
        }
      )
    }
  }

  getElementsForTags(tags) {
    if (!tags) {
      return null
    }
    return tags.map((tag) => {
      const li = document.createElement('li')
      const aTag = document.createElement('a')
      aTag.classList.add('tag-button')

      if (tag.link) {
        aTag.href = tag.permalink
      } else {
        const langUrl =
          this.languageSlug === 'en' ? '' : `/${this.languageSlug}`
        const slug = tag.slug
        const urlParams = new URLSearchParams(window.location.search)
        urlParams.set('tag', slug)
        urlParams.set('s', '')
        urlParams.set('category_name', '')
        urlParams.set('order', 'DESC')
        const newUrl = `${
          window.location.origin
        }${langUrl}?${urlParams.toString()}`
        aTag.href = newUrl
      }

      aTag.innerHTML = `
			<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
        <path d="M2.62046 7.33169L4.3746 6.27363L6.12874 7.34561L5.66932 5.34087L7.21464 4.00439L5.18206 3.8234L4.3746 1.93004L3.56714 3.80948L1.53456 3.99046L3.07987 5.34087L2.62046 7.33169ZM1.77123 8.5L2.46175 5.54135L0.165771 3.55221L3.19013 3.29048L4.3746 0.5L5.55906 3.28992L8.58287 3.55165L6.28689 5.54079L6.97797 8.49944L4.3746 6.92907L1.77123 8.5Z" fill="white"/>
      </svg>
			<span data-text="${tag.name}"><span>${tag.name}</span></span>`

      // aTag.textContent = tag.name

      li.appendChild(aTag)
      return li
    })
  }

  checkEqualTags(array1, array2) {
    if (!array1) {
      return false
    }
    if (!array2) {
      return array1 === array2
    }
    return (
      array1.length === array2.length &&
      array1.every(
        (item, index) => JSON.stringify(item) === JSON.stringify(array2[index])
      )
    )
  }

  async fetchTags() {
    this.loading = true
    const lang = document.documentElement.lang || 'en'

    const request = await fetch(
      `${this.apiEndpoint}?lang=${lang}&langSlug=${this.languageSlug}&q=${this.query}`
    ).then((res) => res.json())

    if (!request.error) {
      this.firstLoad = false
      if (!this.checkEqualTags(request.tags, this.tags)) {
        this.displayTags(request.tags)
      }
    }
    // else {
    //   console.log(request)
    // }
  }

  animateIn() {
    this.isOpen = true
    gsap.to(this,{
      autoAlpha: 1,
      duration: .2,
      ease: 'power2.out'
    }).then(() => {
      if (this.input) {
        this.input.focus()
      }
    })
    if (this.tagList && this.tagList.children && this.tagList.children.length > 0) {
      gsap.fromTo(
        this.tagList.children,
        { autoAlpha: 0, y: 5 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.25,
          stagger: 0.02,
          ease: 'power2.out'
        }
      )
    }
  }

  animateOut() {
    this.isOpen = false
    gsap.to(this,{
      autoAlpha: 0,
      duration: .2,
      ease: 'power2.out'
    })
  }
}
